// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  firebase: {
    apiKey: "AIzaSyDeFrip7Pbp_3qxAuTgflhS-EH6ZbZhPrg",
    authDomain: "adacad-beta-fa4dc.firebaseapp.com",
    databaseURL: "https://adacad-beta-fa4dc-default-rtdb.firebaseio.com",
    projectId: "adacad-beta-fa4dc",
    storageBucket: "adacad-beta-fa4dc.appspot.com",
    messagingSenderId: "256364414107",
    appId: "1:256364414107:web:bd7439b027c997eb1c723e",
    measurementId: "G-CM8RPB246D"
  },
  production: false
};
